import { useState, useEffect, useRef } from "react";

export const useSubmenu = () => {
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const submenuRef = useRef<HTMLLIElement>(null);

  // Fecha o submenu ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (submenuRef.current && !submenuRef.current.contains(event.target as Node)) {
        setSubmenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Alterna a visibilidade do submenu ao clicar
  const toggleSubmenu = (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();
    setSubmenuOpen((prev) => !prev);
  };

  return { submenuOpen, toggleSubmenu, submenuRef };
};
